import * as angular from 'angular';
import * as _ from 'lodash';
import * as moment from 'moment';
import template from './shopCountSummaryReport.tpl.html';
import {States, Strings} from "../../shared/config/constant.module";
import {StateParams} from "../../common";
import {apsEnums} from "../../shared/dto/aps.enums";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import {ICommonQueryingReport} from "./commonQueryingReport";
import {Plant} from "../../models/navigation";
import {DefectType} from "../../models/defectType";
import UIUtilityServiceName, {EnumOption, UIUtilityService} from "../../services/utility/uiUtility.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import CountsServiceName, {CountsService} from "../../services/counts/counts.service";
import DateUtilityService from "../../services/utility/dateutility.service";
import ShopServiceName, {ShopService} from "../../services/shops/shops.service";
import NavigationServiceName, {NavigationService} from "../../services/navigation/navigation.service";
import DefectTypeServiceName, {DefectTypeService} from "../../services/defects/defectType.service";
import { NotifyService } from '../../services/notify/notify.service';

let requires = [UIUtilityServiceName, LoaderServiceName, CountsServiceName, ShopServiceName, NavigationServiceName,
  DefectTypeServiceName];

interface ShopCountSummaryReportParams extends StateParams {
  reportPlantId: string;
  reportShopId: string;
  startDate: string;
  endDate: string;
  orderBy: apsEnums.DefectOrder;
  autoRun: boolean;
  showByShiftOption: boolean;
}


class ShopCountSummaryReportCtrl implements ICommonQueryingReport {
  plants: Plant[];
  selectedPlant: Plant;
  selectedShop: apsViewModels.ShopNavigation;
  requirePlantSelection: boolean;
  requireShopSelection: boolean;

  startDate: Date;
  endDate: Date;
  uiStartDate: Date;
  uiEndDate: Date;

  defectTypes: DefectType[];
  orderBys: EnumOption[];

  orderBy: apsEnums.DefectOrder;
  showDefectComments: boolean;

  reportStartDate: Date;
  reportEndDate: Date;
  reportShopId: string;
  reportShopName: string;
  reportTimeZoneId: string;
  report: apsViewModels.ShopCountSummary[];
  byShift: boolean;
  showByShiftOption: boolean;
  form: angular.IFormController;

  searchPerformed: boolean;

  private $state: angular.ui.IStateService;
  private $stateParams: ShopCountSummaryReportParams;
  private $q: angular.IQService;
  private loaderService: LoaderService;
  private countsService: CountsService;
  private notifyService: NotifyService;
  private $timeout: angular.ITimeoutService;

  constructor(
    $q: angular.IQService,
    $timeout: angular.ITimeoutService,
    $state: angular.ui.IStateService,
    $stateParams: ShopCountSummaryReportParams,
    navigationService: NavigationService,
    countsService: CountsService,
    loaderService: LoaderService,
    uiUtilityService: UIUtilityService,
    defectTypeService: DefectTypeService,
    notifyService: NotifyService) {

    let vm = this;

    vm.$q = $q;
    this.$timeout = $timeout;
    vm.$state = $state;
    vm.$stateParams = $stateParams;
    vm.loaderService = loaderService;
    vm.countsService = countsService;
    this.notifyService = notifyService;

    vm.requirePlantSelection = true;
    vm.requireShopSelection = true;

    let now = moment().add(1, 'hours').startOf('hour');
    vm.uiEndDate = now.toDate();
    vm.uiStartDate = now.clone().subtract(1, 'days').toDate();

    defectTypeService.getDefectTypesAndClassifications()
      .then((defectTypeData) => vm.defectTypes = defectTypeData.types);

    vm.orderBys = uiUtilityService.getListOptionsFromEnum(apsEnums.DefectOrder, 1);
    vm.orderBy = apsEnums.DefectOrder.Time;
    vm.showDefectComments = false;
    vm.showByShiftOption = true;

    let promise = navigationService.getNavigation().then((nav) => {
      vm.plants = nav.plants();
      vm.selectedPlant = nav.selectedPlant;
      vm.selectedShop = nav.selectedShop;
      vm.startDate = vm.uiStartDate;
      vm.endDate = vm.uiEndDate;     
      return vm.loadState($stateParams);
    });

    loaderService.loadingPromise(promise);
  }

  loadState(params: ShopCountSummaryReportParams): angular.IPromise<any> {
    if (params.reportPlantId && params.reportShopId && params.reportShopId !== params.shopId) {
      let plant = _.find(this.plants, {id: params.reportPlantId});
      if (plant) {
        let shop = _.find(plant.shops, {id: params.reportShopId});
        if (shop) {
          this.selectedPlant = plant;
          this.selectedShop = shop;
        }
      }
    }
    DateUtilityService.setReportDates(this, params, this.$timeout);


    if (params.orderBy !== undefined) {
      let orderBy = _.find(this.orderBys, { value: +params.orderBy }); // !!!
      if (orderBy) {
        this.orderBy = orderBy.value;
      }
    }

    if (params.autoRun) {
      let loadPromise = this.generateReport();
      this.loaderService.loadingPromise(loadPromise);
      return loadPromise;
    }

    return this.$q.when();
  }

  saveState() {
    let reportShopId = this.selectedShop ? this.selectedShop.id : undefined;
    if (reportShopId === this.$stateParams.shopId) {
      reportShopId = undefined;
    }
    let params: ShopCountSummaryReportParams = {
      plantId: this.$stateParams.plantId,
      shopId: this.$stateParams.shopId,
      userId: this.$stateParams.userId,
      reportPlantId: (reportShopId && this.selectedPlant) ? this.selectedPlant.id : undefined,
      reportShopId: reportShopId,
      startDate: this.startDate ? this.startDate.toISOString() : undefined,
      endDate: this.endDate ? this.endDate.toISOString() : undefined,
      orderBy: this.orderBy,
      showByShiftOption: true,
      autoRun: !this.byShift
    };

    this.$state.transitionTo(this.$state.current.name, params);
  }

  updatePlant(): void {
    this.selectedShop = null;
    this.searchPerformed = false;
  }

  setupReport() {
    if (this.form.$invalid) {
      return;
    }

    this.saveState();

    this.report = null;
    this.searchPerformed = false;
  }


  generateReport(): angular.IPromise<any> {
    this.setupReport();
    let loadPromise = this.runReport();
    this.loaderService.loadingPromise(loadPromise);
    return loadPromise;
  }

  runReport(): angular.IPromise<any> {
    return this.countsService
      .getShopCountSummary(this.selectedShop.id, this.startDate, this.endDate, false)
      .then((summaries) => {
        this.report = this.createCountSummary(summaries);
        this.searchPerformed = true;
      }, this.notifyService.handleApiErrors);
  }


  createCountSummary(summaries: apsViewModels.ShopCountSummary[]): apsViewModels.ShopCountSummary[] {
    let report: apsViewModels.ShopCountSummary[] = [];
    summaries.forEach(item => {
      let reportItem: apsViewModels.ShopCountSummary = {
        date: item.date,
        shift: item.shift,
        name: item.name,
        inspectCount: item.inspectCount,
        rejectCount: item.rejectCount  || 0.0,
        rejectPercent: item.rejectPercent || 0.0,
        equipmentCounts: null
      };
      if (item.equipmentCounts) {
        reportItem.summaryCounts = [];
        item.equipmentCounts.forEach(ecItem => {
          let ecReportItem: apsViewModels.ShopCountSummary = {
            date: item.date,
            shift: item.shift,
            name: ecItem.name.indexOf('-') > -1  ? ecItem.name: ecItem.name + "-" +  ecItem.line,
            inspectCount: ecItem.inspectCount || 0.0,
            rejectCount: ecItem.rejectCount || 0.0,
            rejectPercent: ecItem.rejectPercent || 0.0,
            equipmentCounts: null
          };
          reportItem.summaryCounts.push(ecReportItem);
        });
      }
      report.push(reportItem);
    });
    return report;
  }

  formatTime(time: Date): string {
    return DateUtilityService.formatTime(time, this.reportTimeZoneId);
  }

  exportToCsv() {
    this.setupReport();

    if(this.byShift)
    {
      this.reportStartDate = new Date(this.startDate.getFullYear(), this.startDate.getMonth(), this.startDate.getDate(), 
            0, 0, 0);
      this.reportEndDate = new Date(this.endDate.getFullYear(), this.endDate.getMonth(), this.endDate.getDate(), 
            0, 0, 0);
    }

    let titles = [];
    if( this.byShift ) {
      titles.push("Date", "Shift");
    }
    titles.push("Equipment","Inspect", "Reject", "Reject %", "Rej/Ins");

    let result = [];
    result.push(titles);

    let loadPromise = this.getCountSummaryWithDefects(result);
    this.loaderService.loadingPromise(loadPromise);
    return loadPromise;
  }

  getCountSummaryWithDefects(result) {
    return this.countsService
      .getShopCountSummary(this.selectedShop.id, this.startDate, this.endDate, this.byShift)
      .then((summaries) => {
        this.searchPerformed = true;
        let exportReport = this.createCountSummary(summaries);
        exportReport.forEach(x => {
          result.push({
            date: this.formatTime(x.date),
            shift: x.shift,
            equipment: "\""+x.name+"\"",
            inspect: x.inspectCount,
            reject: x.rejectCount,
            rejectPercent: x.rejectPercent,
            division: x.rejectCount/x.inspectCount
          });
          if (x.summaryCounts && x.summaryCounts.length > 1) {
            x.summaryCounts.forEach(y => {
              result.push({
                date: this.formatTime(x.date),
                shift: y.shift,
                equipment: "\""+y.name+"\"",
                inspect: y.inspectCount,
                reject: y.rejectCount,
                rejectPercent: y.rejectPercent,
                division: (y.inspectCount>0) ? y.rejectCount/y.inspectCount : ""
              });
            });
          }
        });

        this.createDownload(result);
      }, this.notifyService.handleApiErrors);
  }
  
  createDownload(data: any[] ) {
    let fileName = "ShopCountSummary-"+this.selectedPlant.name+this.selectedShop.name+"-";
    if( this.byShift ) {
      fileName += moment(this.reportStartDate).format(Strings.DATE_FORMAT)+"-"+moment(this.reportEndDate).format(Strings.DATE_FORMAT);
      fileName += "-ByShift";
    } else {
      fileName += moment(this.reportStartDate).format(Strings.ISO_FORMAT)+"-"+moment(this.reportEndDate).format(Strings.ISO_FORMAT);
    }
    fileName +=".csv"

    let csv = data[0].join(',') + "\n";
    for (let i = 1; i < data.length; i++) {
      if( this.byShift ) {
        csv += moment(data[i].date).format(Strings.DATE_FORMAT) + ',' + data[i].shift + ',';
      }
      csv += data[i].equipment + ',' + data[i].inspect + ',' + data[i].reject + ',' + data[i].rejectPercent + ',' +data[i].division + "\n";
    }

    var a = document.createElement("a");
    a.href = 'data:attachment/csv;charset=utf-8,' + encodeURI(csv);
    a.target = '_blank';
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
  }
}


export default angular.module('aps.controller.shopCountSummaryReport', requires)
  .config(function ($stateProvider: angular.ui.IStateProvider) {
    $stateProvider.state({
      name: States.SHOP_COUNT_SUMMARY,
      url: '/admin/reports/shopCountSummary?startDate&endDate&orderBy&autoRun&reportPlantId&reportShopId',
      params: {
        startDate: {dynamic: true},
        endDate: {dynamic: true},
        orderBy: {dynamic: true},
        autoRun: {dynamic: true},
        reportPlantId: {dynamic: true},
        reportShopId: {dynamic: true},
      },
      controller: 'ShopCountSummaryReportCtrl as vm',
      template: template,
      data: {
        pageTitle: 'Shop Count Summary'
      }
    });
  })
  .controller('ShopCountSummaryReportCtrl', ShopCountSummaryReportCtrl)
  .name;


// WEBPACK FOOTER //
// ./src/app/controllers/reports/shopCountSummaryReport.controller.ts